import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getDeviceTaskDetail } from '@blade-sxp/pass/api/access-management/access-list';
import { repostPortrait } from '@blade-sxp/pass/api/access-management/device-management';
let default_1 = class extends Vue {
    data = {};
    device = {};
    portrait = [];
    black = [];
    white = [];
    visitor = [];
    deviceId;
    taskId;
    successCount = '--';
    errorCount = '--';
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    handleSizeChange(e) {
        this.pagination.size = e;
        this.getData();
    }
    handleCurrentChange(e) {
        this.pagination.page = e;
        this.getData();
    }
    handleGotoSchedule() {
        const id = this.data?.taskDetailInfo?.timeTableId || '';
        this.$router.push('/traffic/management/task/passSchedule/edit/' + id);
        // this.$router.push({ path: '/traffic/device/syncDetail', query: { deviceId: id } });
    }
    handelManual(data) {
        repostPortrait(data?.portraitId).then(res => {
            this.$message.success(`${this.$t('success')}`);
        }).catch(error => {
            this.$message({ type: 'error', message: error });
        });
    }
    getData() {
        const requestData = {
            page: this.pagination.page,
            size: this.pagination.size,
            deviceId: this.deviceId,
            taskId: this.taskId
        };
        getDeviceTaskDetail(requestData).then(resp => {
            if (resp?.data?.code === 0) {
                this.data = resp?.data?.data || undefined;
                this.pagination.total = this.data.deviceDbsyncInfo.total;
                this.device = this.data?.taskDetailInfo?.deviceInfo || {};
                this.white = this.data?.taskDetailInfo?.userGroupLibInfos || [];
                this.visitor = this.data?.taskDetailInfo?.visitorGroupLibInfos || [];
                this.black = this.data?.taskDetailInfo?.blackListGroupLibInfos || [];
                this.portrait = this.data.deviceDbsyncInfo.list || [];
                this.successCount = this.data?.taskDetailInfo?.successCount === undefined ? '--' : this.data?.taskDetailInfo?.successCount;
                this.errorCount = this.data?.taskDetailInfo?.errorCount === undefined ? '--' : this.data?.taskDetailInfo?.errorCount;
                // this.pagination.size = this.data.deviceDbsyncInfo.size;
            }
            else {
                this.$message.error(resp.data.message || '');
            }
        }).catch(error => {
            this.$message({ type: 'error', message: error });
        });
    }
    mounted() {
        const query = this.$route.query;
        this.deviceId = query.deviceId;
        this.taskId = query.taskId;
        this.getData();
    }
};
default_1 = __decorate([
    Component({
        components: {},
        i18n: {
            messages: {
                'en-us': {
                    group: 'Group',
                    staff: 'Staff group issued details',
                    recently: 'Recently synchronized records',
                    success: 'Success',
                    error: 'Error',
                    schedule: 'Traffic schedule',
                },
                zh: {
                    group: '所属组别',
                    staff: '人员组下发详情',
                    recently: '最近同步记录',
                    success: '成功',
                    error: '失败',
                    schedule: '通行时刻表',
                },
            },
        },
    })
], default_1);
export default default_1;
